import { Component, OnInit , Input} from '@angular/core';
import {Router} from '@angular/router';
import {DataService} from '../data.service';
import {environment} from '../../environments/environment';
@Component({
  selector: 'app-footer-icons',
  templateUrl: './footer-icons.component.html',
  styleUrls: ['./footer-icons.component.css']
})
export class FooterIconsComponent implements OnInit {
  footerflag:  boolean = false;
  @Input() userTypeId:number;
  @Input() planId:number;
  @Input() isHome:boolean;
  @Input() isSearch:boolean;
  isNext:boolean=false;
  companyModuleData:any[];
  constructor(private router:Router,private service:DataService) { }

  ngOnInit() {
    this.companyModuleData=sessionStorage.getItem('companyModuleData')!=null ? JSON.parse(sessionStorage.getItem('companyModuleData')) : []
    this.service.watchCompanyData().subscribe(()=>{
      this.companyModuleData=sessionStorage.getItem('companyModuleData')!=null ? JSON.parse(sessionStorage.getItem('companyModuleData')) : []
    })
    if(environment.footer40){
      this.footerflag=true;
    }
    else{
      this.footerflag=false;
    }
  }

  showActiveModule(pvarChoice){

    pvarChoice = 3;

    if(pvarChoice==0){
      // this.isFavourite=true;
      return "/all-modules/Favourite";
    }

    if(pvarChoice==1){
      // this.isTrending=true;
      return "/all-modules/Trending";
    }

    if(pvarChoice==2){
      // this.isRecommended=true;
      return "/all-modules/Recommended";
    }

    if(pvarChoice==3){
      // this.isFree=true;
      return "/all-modules/Free";
    }

    if(pvarChoice==4){
      // this.isNew=true;
      return "/all-modules/New";
    }

    if(pvarChoice==5){
      // this.isEditor=true;
      return "/all-modules/Editor's Pick";
    }

    if(pvarChoice==6){
      // this.isPending=true;
      return "/all-modules/Pending";
    }

    if(pvarChoice==7){
      // this.isCompleted=true;
      return "/all-modules/Completed";
    }

    if(pvarChoice==8){
      // this.isCompany=true;
      return "/all-modules/Company";
    }

  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/footer-icons/footer-icons.component.ts